import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import userAvatar from "../assets/img/img1.jpg";
import '../assets/css/sidebar.css';
import { useAuth } from "../hooks/useAuth";

import {
    getDashboardMenu,
    applicationsMenu,
} from "../data/Menu";

// Composant fonctionnel pour utiliser le hook useAuth
const SidebarFooter = ({ toggleFooterMenu }) => {
    const { user, logout } = useAuth();

    const handleLogout = () => {
        logout();
    };

    return (
        <div className="sidebar-footer">
            <div className="sidebar-footer-top" style={{marginTop:'-410px'}}>
                <div className="sidebar-footer-thumb">
                    <img src={userAvatar} alt={user ? `${user.firstname} ${user.lastname}` : 'Utilisateur'} />
                </div>
                <div className="sidebar-footer-body">
                    <h6>
                        <Link to="/apps/MonCompte">
                            {user ? (
  `${user.firstname} ${user.lastname}`.length > 15 
    ? `${user.firstname} ${user.lastname}`.slice(0, 15) + '...'
    : `${user.firstname} ${user.lastname}`
) : 'Minerve-Tech'}
                        </Link>
                    </h6>
                    <p>
                        {user?.business_name ? user.business_name : 'Type de canal: Notification'}
                    </p>
                    {user?.business_city && (
                        <small className="text-muted">
                            <i className="ri-map-pin-line me-1"></i>
                            {user.business_city}, {user.business_country}
                        </small>
                    )}
                </div>
                <Link onClick={toggleFooterMenu} to="" className="dropdown-link">
                    <i className="ri-arrow-down-s-line"></i>
                </Link>
            </div>
            
            <div className="sidebar-footer-menu">
                <nav className="nav">
                    <Link to="/apps/Entreprise">
                        <i className="ri-home-line me-2"></i> 
                        Entreprise
                    </Link>
                    <Link to="/apps/Membres">
                        <i className="ri-user-settings-line me-2"></i> 
                        Membres
                    </Link>
                    <Link to="/apps/MonCompte">
                        <i className="ri-profile-line me-2"></i> 
                        Mon profil
                    </Link>
                    <Link 
                        to="" 
                        onClick={handleLogout}
                        className="text-danger"
                    >
                        <i className="ri-logout-box-r-line me-2"></i> 
                        Déconnexion
                    </Link>
                </nav>
            </div>

            <style>{`
                .nav-item-with-progress {
                    margin-bottom: 5px;
                }

                .progress-label {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 5px;
                    font-size: 0.85rem;
                }

                .progress-value {
                    font-size: 0.8rem;
                    color: #6c757d;
                }

                .progress {
                    height: 6px;
                    background-color: #e9ecef;
                    border-radius: 3px;
                    overflow: hidden;
                    margin-bottom: 8px;
                }

                .progress-bar {
                    height: 100%;
                    background-color: #007bff;
                    border-radius: 3px;
                    transition: width 0.3s ease;
                }

                .nav-link-action {
                    font-size: 0.8rem;
                    color: #007bff;
                    text-decoration: none;
                }

                .nav-link-action:hover {
                    text-decoration: underline;
                }

                .manage-button-container {
                    width: 100%;
                    display: block;
                }

                .sidebar-footer-body small {
                    font-size: 0.75rem;
                    opacity: 0.8;
                }
            `}</style>
        </div>
    );
};

// Composant pour utiliser le hook useAuth dans SidebarMenu
const SidebarMenuWithAuth = (props) => {
    const { user } = useAuth();
    
    return <SidebarMenu {...props} user={user} />;
};

// HOC pour fournir l'utilisateur au composant Sidebar
const withUserData = (WrappedComponent) => {
    return class extends Component {
        constructor(props) {
            super(props);
            this.state = {
                user: null
            };
        }

        componentDidMount() {
            this.getUserData();
        }

        getUserData = () => {
            try {
                const userData = localStorage.getItem("userData");
                if (userData) {
                    const parsedUserData = JSON.parse(userData);
                    this.setState({ user: parsedUserData });
                }
            } catch (error) {
                console.error("❌ Erreur lecture userData:", error);
            }
        }

        render() {
            return <WrappedComponent {...this.props} user={this.state.user} />;
        }
    };
};

class SidebarWithoutUser extends Component {
    toggleFooterMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest(".sidebar");
        parent.classList.toggle("footer-menu-show");
    }

    render() {
        const { user } = this.props;
        
        return (
            <div className="sidebar">
                {user?.acc_type === 'admin' ? (
                    <div className="sidebar-header">
                        <Link to="/dashboard/finance" className="sidebar-logo">BULK SMS</Link>
                    </div>
                ) : (
                    <div className="sidebar-header">
                        <Link to="/" className="sidebar-logo">BULK SMS</Link>
                    </div>
                )}
                
                <PerfectScrollbar 
                    className="sidebar-body" 
                    ref={ref => this._scrollBarRef = ref}
                >
                    <SidebarMenuWithAuth 
                        onUpdateSize={() => this._scrollBarRef && this._scrollBarRef.updateScroll()} 
                    />
                </PerfectScrollbar>
                
                {/* Utilisation du composant SidebarFooter avec les données utilisateur */}
                <SidebarFooter toggleFooterMenu={this.toggleFooterMenu} />
            </div>
        )
    }
}

// Appliquer le HOC pour obtenir les données utilisateur
const Sidebar = withUserData(SidebarWithoutUser);

export default Sidebar;

class SidebarMenu extends Component {
    state = {
        kycStatus: null,
        loading: true
    }

    componentDidMount() {
        this.checkKYCStatus();
    }

    checkKYCStatus = () => {
        try {
            const userData = localStorage.getItem("userData");
            if (userData) {
                const parsedUserData = JSON.parse(userData);
                console.log("🔍 Statut KYC dans SidebarMenu:", parsedUserData.kyc);
                this.setState({ kycStatus: parsedUserData.kyc });
            }
        } catch (error) {
            console.error("❌ Erreur lecture KYC:", error);
        } finally {
            this.setState({ loading: false });
        }
    }

    populateMenu = (m) => {
        const menu = m.map((m, key) => {
            let sm;
            if (m.submenu) {
                sm = m.submenu.map((sm, key) => {
                    return (
                        <NavLink
                            to={sm.link}
                            key={key}
                            className={({ isActive }) =>
                                isActive ? "nav-sub-link active text-primary fw-semibold" : "nav-sub-link"
                            }
                        >
                            {sm.label}
                        </NavLink>
                    )
                })
            }

            return (
                <li key={key} className="nav-item">
                    {(!sm) ? (
                        <NavLink
                            to={m.link}
                            className={({ isActive }) =>
                                isActive ? "nav-link active" : "nav-link"
                            }
                        >
                            <i className={m.icon}></i> <span>{m.label}</span>
                        </NavLink>
                    ) : (
                        <div onClick={this.toggleSubMenu} className="nav-link has-sub">
                            <i className={m.icon}></i> <span>{m.label}</span>
                        </div>
                    )}
                    {m.submenu && <nav className="nav nav-sub">{sm}</nav>}
                </li>
            )
        });

        return (
            <ul className="nav nav-sidebar">
                {menu}
            </ul>
        );
    }

    // Toggle menu group
    toggleMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest('.nav-group');
        parent.classList.toggle('show');
        this.props.onUpdateSize();
    }

    // Toggle submenu while closing siblings' submenu
    toggleSubMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest('.nav-item');
        let node = parent.parentNode.firstChild;

        while (node) {
            if (node !== parent && node.nodeType === Node.ELEMENT_NODE)
                node.classList.remove('show');
            node = node.nextElementSibling || node.nextSibling;
        }

        parent.classList.toggle('show');
        this.props.onUpdateSize();
    }

    render() {
        const { kycStatus, loading } = this.state;
        const { user } = this.props;

        // Récupérer le menu dynamiquement selon l'utilisateur
        const dashboardMenu = getDashboardMenu(user);

        // Si en cours de chargement
        if (loading) {
            return (
                <React.Fragment>
                    <div className="nav-group show">
                        <div className="nav-label">NAVIGATION</div>
                        <div className="p-3 text-center">
                            <div className="spinner-border spinner-border-sm text-primary me-2"></div>
                            <span className="text-muted small">Chargement...</span>
                        </div>
                    </div>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                {/* Afficher les groupes seulement si KYC n'est pas "KO" */}
                {kycStatus !== "KO" && (
                    <>
                        <div className="nav-group show">
                            <div className="nav-label" onClick={this.toggleMenu}>NAVIGATION</div>
                            {this.populateMenu(dashboardMenu)}
                        </div>
                        {/* <div className="nav-group show">
                            <div className="nav-label" onClick={this.toggleMenu}></div>
                            {this.populateMenu(applicationsMenu)}
                        </div> */}
                    </>
                )}
                
                {/* Message si KYC est KO */}
                {kycStatus === "KO" && (
                    <div className="nav-group show">
                        <div className="nav-label">INFORMATION</div>
                        <div className="p-3 text-center">
                            <i className="ri-information-line text-warning fs-2 mb-2 d-block"></i>
                            <p className="text-muted small mb-0">
                                Votre compte est en cours de validation
                            </p>
                            <p className="text-muted small">
                                Contactez le support pour plus d'informations
                            </p>
                        </div>
                    </div>
                )}
            </React.Fragment>
        )
    }
}

window.addEventListener("click", function (e) {
    // Close sidebar footer menu when clicked outside of it
    let tar = e.target;
    let sidebar = document.querySelector(".sidebar");
    if (!tar.closest(".sidebar-footer") && sidebar) {
        sidebar.classList.remove("footer-menu-show");
    }

    // Hide sidebar offset when clicked outside of sidebar
    if (!tar.closest(".sidebar") && !tar.closest(".menu-link")) {
        document.querySelector("body").classList.remove("sidebar-show");
    }
});

window.addEventListener("load", function () {
    let skinMode = localStorage.getItem("sidebar-skin");
    let HTMLTag = document.querySelector("html");

    if (skinMode) {
        HTMLTag.setAttribute("data-sidebar", skinMode);
    }
});